import { ApplyPositionView } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/ApplyPositionView';
import { ModalRoutingService } from 'services';

export const PositionsAllocationComponentMap = {
  ApplyPositionView,
};

export const positionsAllocationModalRoutingService = new ModalRoutingService(
  'positionsAllocation',
  'ApplyPositionView',
  PositionsAllocationComponentMap,
  { positionId: 'string' },
  ['ApplyPositionView'],
);
